  <template>
  <div>
   <b-modal style="padding:15px" size="lg" id="AddStockTakeShipmentGovtModal" ref="modal" title="Add Shipment (Govt)" ok-title="Submit" cancel-title="Close" 
      @show= "updateModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddShipmentGovtForm != undefined ? !this.$refs.AddShipmentGovtForm.checkValidity() : true">
        <form ref="AddShipmentGovtForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
          
            <div class="col-md-6">
               <b-form-group  label="Shipment Date" label-for="datepicker-2" autocomplete="off">
                  <b-form-datepicker id="datepicker-1" v-model= "ShipmentDate" placeholder="Choose a date" local="en" required></b-form-datepicker>
               </b-form-group>
            </div>  
            <div class = "col-md-6">
              <b-form-group  label="Voucher No" label-for="voucherno" autocomplete="off">
                <b-form-input id="voucherno" v-model= "VoucherNo" required></b-form-input>
              </b-form-group>
            </div>
            <div class = "col-md-6">
              <b-form-group  label="Truck No" label-for="truckno" autocomplete="off">
                <b-form-input id="truckno" v-model= "TruckNo"  required></b-form-input>
              </b-form-group>
            </div>
           
            <div class="col-md-6">
              <b-form-group label="Depot" label-for="Depo" autocomplete="off">
                <b-form-select v-model= "SelectedDepoId" :options="deposList" value-field="id" text-field="name" required>
                  <b-form-select-option :value = null disabled hidden>Select Depot</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
               <div class="col-md-6">
              <b-form-group label="Contractor" label-for="Contractor" autocomplete="off">
                <b-form-select v-model= "SelectedContractorId" :options="contractorsList" value-field="id" text-field="name" required>
                  <b-form-select-option :value = null disabled hidden>Select Contractor</b-form-select-option>
                </b-form-select>
              </b-form-group>
            </div>
              <div class="col-md-6">
              <b-form-group label="Product" label-for="Product" autocomplete="off">
               <b-form-input id="flourtype" v-model= "flourObject.flourName" type = "text" disabled></b-form-input>
              </b-form-group>
            </div>
             <div class="col-md-6">
              <b-form-group label="Bag Type" label-for="BagType" autocomplete="off">
                <b-form-input id="flourweight" v-model= "flourObject.flourWeight" type = "text" disabled></b-form-input>
              </b-form-group>
            </div>
           
             <div class = "col-md-6">
              <b-form-group  label="No Of Sacks" label-for="sacks" autocomplete="off">
                <b-form-input id="sacks" v-model= "NoOfSacks" type = "number"  required></b-form-input>
              </b-form-group>
            </div>
              <div class = "col-md-12">
              <b-form-group  label="" label-for="checkbox" autocomplete="off">
               <b-form-checkbox @change="chkvalue()"
                id="checkbox"
                v-model="IsInventoryTransaction"
                name="checkbox-1"
                value: = true
                unchecked-value: = false
              >
               Inventory Transaction
              </b-form-checkbox >
              </b-form-group>
            </div>

            </div>
            
        </form>
      </b-modal>
      <Toaster ref ="toaster"/>
      </div>
      </template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'
export default {
    name: 'AddShipmentGovt',
    mounted()
    {
     
      this.getDepos();
      this.getContractors();
     
      // console.log(this.$auth.user())
    },
    components:{
      Toaster
    },
     props:{
     flourObject:{
      type:Object,
      default:null
    },
    isAdjustment:{
      type:Boolean,
      default:false
    }

  },
    data(){
        return{
          moduleName:'Add Shipment (Govt)',   
          ShipmentDate:null,
         
          VoucherNo: null,
          TruckNo : null,
          NoOfSacks: 1,
          SelectedDepoId:null,
          deposList:[],
          SelectedContractorId:null,
          contractorsList:[],
          IsInventoryTransaction:true,

          shipmentEntries:[],
      
         
         
          
		}
  },
  // watch:{
  //    IsInventoryTransaction(newVal, oldVal)
  //    {
  //      console.log(newVal)
  //       console.log(oldVal)
  //    }
  // },
methods:{
  chkvalue()
  {
    console.log(this.IsInventoryTransaction)
  },
   getDepos()
   {
    let model = {
            "CompanyId":this.$auth.user().companyId,
            
          }
          axios.post('/depo/getall', model)
          .then(res=>{
          
            this.deposList = res.data.data
          });
   },

    getContractors()
   {
    let model = {
            "CompanyId":this.$auth.user().companyId,
            
          }
          axios.post('/contractor/getall', model)
          .then(res=>{
       
            this.contractorsList = res.data.data
          });
   },

  

 
   AddShipmentGovt(){ 
     this.shipmentEntries = [];

        let shipmentEntryModel = {
      NoOfSacks:parseFloat(this.NoOfSacks),
      FlourTypeId:this.flourObject.flourId,
      IsInventoryTransaction:this.IsInventoryTransaction,
      FlourWeightId:this.flourObject.flourWeightId,
     
    }
    // console.log(this.shipmentEntries);

    this.shipmentEntries.push(shipmentEntryModel); //at backend an array is receiving entry so this entry has to be in array from
// console.log(this.shipmentEntries);
      let model = {
      "ShipmentDate":this.ShipmentDate,
      "VoucherNo":this.VoucherNo,
      "TruckNo":this.TruckNo,
      "DepoId":this.SelectedDepoId,
      "ContractorId":this.SelectedContractorId,
      "IsAdjustmentEntry":this.isAdjustment,
      "IsStockTakeEntry":true,
      "CompanyId":this.$auth.user().companyId,
      "UserId":this.$auth.user().id,
      "ShipmentEntries":this.shipmentEntries,
      }
    // console.log(model)
     axios.post('/shipment/Add', model
      )
      .then(res=>{
      
            if(res.data.status == 1)
            {   
                this.$refs.toaster.showToast('Sucess','success','Shipment has been added successfully')
                this.$bvModal.hide('AddStockTakeShipmentGovtModal')
                this.$parent.MarkEntryAsDone(this.flourObject.flourWeightTypeLinkId);
            }
            else
            {
               this.$refs.toaster.showToast('Error','danger',res.data.msg)      
            }
           
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddShipmentGovtForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
    
      updateModal() {
           this.VoucherNo= null
           this.TruckNo = null
           this.NoOfSacks= 1
         
          this.ShipmentDate = new Date();
       
        // this.SelectedFlourType = this.flourObject.flourId;
        // this.SelectedFlourWeight = this.flourObject.flourWeightId;  
           this.SelectedDepoId=null
           this.shipmentEntries = [];
           this.SelectedContractorId=null
           this.IsInventoryTransaction=true
     
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        if(this.SelectedContractorId == null || this.SelectedDepoId == null)
        {
          this.$refs.toaster.showToast("Error",'danger',"Select depo and contractor")
          return;
        }
        this.AddShipmentGovt()
       
        // this.$nextTick(() => {
        //   //this.$router.go('/phones')
        //   this.$bvModal.hide('AddShipmentGovtdModal')
        
        // })
      },

 

  }
	

}
</script>
